import Navbar from './components/Navbar';
import Footer from './components/Footer';
import './App.css';

function SpecialEvents() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section with Title */}
      <div className="mt-16 md:mt-24 bg-white">
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-8 md:py-12">
          <h1 className="text-4xl md:text-6xl text-center uppercase italic tracking-[0.2em] md:tracking-[0.3em] mb-6 md:mb-8 font-light">
            SPECIAL EVENTS
          </h1>
        </div>

        {/* Hero Image - Full Width */}
        <div className="w-full">
          <img 
            src="/special-event.webp" 
            alt="Special Events Sunset" 
            className="w-full h-[300px] md:h-[500px] object-cover"
          />
        </div>

        {/* Content Section */}
        <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12 md:py-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-8 md:mb-12 text-center uppercase italic tracking-[0.15em] md:tracking-[0.2em]" style={{ color: '#F5A623' }}>
            Book your event at Throttle Edge!
          </h2>

          <div className="space-y-4 md:space-y-6 text-gray-800 leading-relaxed text-sm md:text-base max-w-4xl mx-auto">
            <p>
              Are you looking for a unique and exciting venue to host your next event? Look no further than Throttle Edge! 
              Our picturesque location offers the perfect setting for a variety of special occasions, including birthday parties, 
              buck and doe parties, corporate events, bachelor/bachelorette gatherings, and more.
            </p>

            <p>
              Whether you're seeking an adrenaline-pumping off-road experience or a serene outdoor retreat, Throttle Edge has 
              something for everyone. Our skilled team is dedicated to ensuring your event is an unforgettable success, tailored 
              to your specific needs and preferences.
            </p>

            <p>
              To inquire about hosting an event at Throttle Edge, please feel free to contact us. Additionally, you can fill out 
              the form below with details such as preferred dates, type of occasion, number of guests, and any special requests. 
              Our team will be happy to assist you in planning your memorable event.
            </p>

            <p>
              We look forward to helping you create lasting memories at Throttle Edge. Contact us today to start planning your 
              next event with us!
            </p>
          </div>

          {/* Contact Us Button */}
          <div className="flex justify-center mt-8 md:mt-12">
            <button className="border-2 border-black text-black px-8 md:px-12 py-3 hover:bg-black hover:text-white transition-colors uppercase text-xs md:text-sm font-bold tracking-widest">
              Contact Us
            </button>
          </div>
        </div>

        {/* Form Section */}
        <div className="bg-gray-50 py-12 md:py-16">
          <div className="max-w-[1200px] mx-auto px-4 md:px-6">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 md:mb-12 text-center uppercase italic tracking-[0.1em] md:tracking-[0.15em]" style={{ color: '#F5A623' }}>
              Please fill out the form below
            </h2>

            <form className="max-w-3xl mx-auto space-y-4 md:space-y-6">
              {/* Name Section */}
              <div>
                <label className="block text-sm font-semibold mb-3 md:mb-4">Name</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                  <div>
                    <input 
                      type="text" 
                      required
                      className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                      placeholder=""
                    />
                    <p className="text-xs text-gray-600 mt-2">First Name (required)</p>
                  </div>
                  <div>
                    <input 
                      type="text" 
                      required
                      className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                      placeholder=""
                    />
                    <p className="text-xs text-gray-600 mt-2">Last Name (required)</p>
                  </div>
                </div>
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-semibold mb-2">Email (required)</label>
                <input 
                  type="email" 
                  required
                  className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  placeholder=""
                />
              </div>

              {/* Type of Event */}
              <div>
                <label className="block text-sm font-semibold mb-2">Type of Event (required)</label>
                <input 
                  type="text" 
                  required
                  className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  placeholder=""
                />
              </div>

              {/* Date */}
              <div>
                <label className="block text-sm font-semibold mb-2">Date (required)</label>
                <input 
                  type="date" 
                  required
                  className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  placeholder="mm/dd/yyyy"
                />
              </div>

              {/* Number of Guests */}
              <div>
                <label className="block text-sm font-semibold mb-2">Number of Guests (required)</label>
                <input 
                  type="number" 
                  required
                  className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                  placeholder=""
                  min="1"
                />
              </div>

              {/* Phone Number */}
              <div>
                <label className="block text-sm font-semibold mb-3 md:mb-4">Phone Number</label>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  <div>
                    <label className="block text-xs text-gray-600 mb-2">Country</label>
                    <select className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400">
                      <option value="Pakistan">Pakistan</option>
                      <option value="USA">USA</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-span-1 md:col-span-2">
                    <label className="block text-xs text-gray-600 mb-2">Number</label>
                    <input 
                      type="tel" 
                      className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400"
                      placeholder="+1"
                    />
                  </div>
                </div>
              </div>

              {/* Event Info */}
              <div>
                <label className="block text-sm font-semibold mb-2">Event Info</label>
                <textarea 
                  rows="5"
                  className="w-full px-4 py-3 bg-gray-200 border-0 focus:outline-none focus:ring-2 focus:ring-gray-400 resize-none"
                  placeholder="Event info, special requests, etc..."
                ></textarea>
              </div>

              {/* Submit Button */}
              <div className="pt-4 md:pt-6 flex justify-center">
                <button 
                  type="submit"
                  className="border-2 border-black text-black px-12 md:px-16 py-3 hover:bg-black hover:text-white transition-colors uppercase font-bold tracking-widest text-xs md:text-sm"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default SpecialEvents;
